import { lazy, Suspense } from 'react';
import { Outlet, Navigate, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Loading, ScrollRestoration } from '@laboratoria/sdk-react';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { IntlProvider } from '../../intl';

const Home = lazy(() => import('../Home'));
const TopBar = lazy(() => import('../TopBar'));
const Program = lazy(() => import('../Program'));
const Project = lazy(() => import('../Project'));
const Projects = lazy(() => import('../Projects'));
const Topic = lazy(() => import('../Topic'));
const Topics = lazy(() => import('../Topics'));

const NotFound = () => {
  return (
    <Container>
      <Alert severity="error">
        <FormattedMessage id="page-not-found" />
      </Alert>
    </Container>
  );
};

const RoutesWithIntl = ({ defaultLang, user }) => {
  const location = useLocation();
  const { lang } = useParams();

  if (!['es', 'pt'].includes(lang)) {
    return (
      <Navigate to={`/${defaultLang}${location.pathname}${location.search}`} />
    );
  }

  return (
    <Suspense fallback={<Loading />}>
      <IntlProvider lang={lang}>
        <ScrollRestoration />
        <TopBar lang={lang} />
        <Routes>
          <Route path="/:track" element={<Program lang={lang} />} />
          <Route path="/:track/projects" element={<Projects lang={lang} />} />
          <Route path="/projects/:slug" element={<Project lang={lang} />} />
          <Route path="/:track/topics" element={<Topics lang={lang} />} />
          <Route path="/topics/:slug/*" element={<Topic lang={lang} />} />
          <Route path="/" element={<Home lang={lang} />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </IntlProvider>
    </Suspense>
  );
};

export default RoutesWithIntl;
